import { useState, useEffect } from 'react';
import { Button, Modal, Form, Spinner, Row, Col } from 'react-bootstrap';
import { Portfolios, Brokers } from 'Services';
import { useSelector } from 'react-redux';
import { ConfirmationModal, InformationModal } from 'Components/Common/Modal';
import { convertIntoTitleCase } from 'Utils';

// Validation
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './validation';

export default (props) => {
  const [portfolioVals, setPortfolioVals] = useState({});
  const [properties, setProperties] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const user = useSelector((state) => state.auth.user);

  const {
    selectedportfolio: { portfolioId, avatarUrl, label, brokerId },
    getconnectedportfolios,
    onHide,
    show,
  } = props;

  const handleSubmit = async (values) => {
    try {
      const propsData = { ...values };
      delete propsData.label;

      await Portfolios.updatePortfolioDetails(user.id, portfolioId, {
        label: values.label,
        values: propsData,
      });
      await InformationModal('Portfolio has been updated!');
      getconnectedportfolios();
      onHide();
    } catch (error) {
      console.error(error);
    }
  };

  const handleRemovePortfolio = async () => {
    const result = await ConfirmationModal('Are you sure?');
    if (result.isConfirmed) {
      try {
        await Portfolios.removePortfolio(user.id, portfolioId);
        getconnectedportfolios();
        onHide();
      } catch (error) {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    const getProperties = async () => {
      setIsLoading(true);
      try {
        const { keys } = await Brokers.getProperties(brokerId, user.id);
        const updatedKey = keys.map((key) => {
          key = key.replace(/\s/g, '_');
          return key;
        });
        setProperties(updatedKey);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    if (brokerId) getProperties();
  }, [brokerId, user.id]);

  useEffect(() => {
    const getPortfolioDetails = async () => {
      try {
        const res = await Portfolios.getConnectedPortfolioDetails(portfolioId);
        setPortfolioVals(res.values);
      } catch (error) {
        console.error(error);
      }
    };
    if (portfolioId) getPortfolioDetails();
  }, [portfolioId]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues({ label, properties, vals: portfolioVals }),
    onSubmit: handleSubmit,
    validationSchema: validationSchema(properties),
  });

  return (
    <Modal size="lg" centered className="update-portfolio-modal" animation={false} onHide={onHide} dialogClassName="modal-42w" show={show}>
      <Modal.Header closeButton>
        <Modal.Title />
      </Modal.Header>
      <Modal.Body>
        <div className="broker-details">
          <img src={avatarUrl} alt="logo" className="logo" />
        </div>
        {isLoading ? (
          <div>
            <Spinner animation="border" size="lg" className="mt-5" />
          </div>
        ) : (
          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <Col md={12} className="nickname-row">
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="4">
                    Edit Name
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control type="text" placeholder="Enter broker nickname" name="label" {...formik.getFieldProps('label')} />
                  </Col>
                </Form.Group>
              </Col>
              {formik.touched.label && formik.errors.label ? <div className="form-error">{formik.errors.label}</div> : null}

              {properties.map((value) => (
                <div key={value}>
                  <Col md={12} className="nickname-row">
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4">
                        {convertIntoTitleCase(value.replace(/_/g, ' '))}
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          type="text"
                          placeholder={`Enter your ${convertIntoTitleCase(value.replace(/_/g, ' '))}`}
                          name={value}
                          {...formik.getFieldProps(value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  {formik.touched[value] && formik.errors[value] ? <div className="form-error">{formik.errors[value]}</div> : null}
                </div>
              ))}
            </Row>

            <div className="text-center mt-2">
              <Button className="mx-2" type="submit" disabled={formik.isSubmitting}>
                Update {formik.isSubmitting && <Spinner animation="border" size="sm" className="ml-2" />}
              </Button>
              <Button className="mx-2" onClick={handleRemovePortfolio}>
                Remove Portfolio
              </Button>
            </div>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
};
